export const api = {
    GET_ORDER_HISTORY_LIST_API: "/api/orderhistory/list",
    GET_ORDER_HISTORY_REPORT_API: "/api/orderhistory/report"
}